import React from 'react';

import AdminReservationContainer from '../../containers/Order/Admin';

const AdminEditReservation = props => {
  return <AdminReservationContainer reservationEditable {...props} />;
};

export default AdminEditReservation;
